import React from 'react'
import ReactPaginate from 'react-paginate'

const Paginate = ({startValue, endValue, count, pageCount, handlePageClick}) => {
  return (
    <nav className="d-flex justify-content-between flex-column flex-md-row text-center">
            <div className="w-auto d-inline">
              Showing {startValue} to {endValue} of {count} records
            </div>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </nav>
  )
}

export default Paginate